import { useUser } from './use-user';

/**
 * Hook to get the current user's personal workspace BuildHub.
 * Returns the BuildHub where IsPersonalWorkspace is true, or null if not logged in or not found.
 *
 * @returns The personal workspace BuildHub or null
 *
 * @example
 * ```tsx
 * const personalWorkspace = usePersonalWorkspace();
 * if (personalWorkspace) {
 *   console.log('Personal workspace ID:', personalWorkspace.ID);
 * }
 * ```
 */
export const usePersonalWorkspace = () => {
    const user = useUser();

    if (user.__typename !== 'Me') {
        return null;
    }

    const personalWorkspace = user.OwnedBuildHubs?.find(
        (bh) => bh.IsPersonalWorkspace,
    );

    return personalWorkspace ?? null;
};
